document.addEventListener('DOMContentLoaded', () => {
    const shareData = {
        title: document.title,
        url: window.location.href
    };

    const btn = document.querySelector(".trigger-share-window");

    btn.addEventListener("click", async () => {
        try {
            console.log(shareData);
            await navigator.share(shareData);
        } catch (err) {
        }
    });
});

